import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
// import QrCode2Icon from "@mui/icons-material/QrCode2";
import SmsIcon from "@mui/icons-material/Sms";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FeedbackIcon from "@mui/icons-material/Feedback";
// import ContactsIcon from "@mui/icons-material/Contacts";
import AddLinkIcon from "@mui/icons-material/AddLink";
// import TablePagination from "@material-ui/core/TablePagination";
// import MaterialTable from "material-table";
import { Select, MenuItem } from "@mui/material";
import React, { Component } from "react";
import { Buffer } from "buffer";
import FetchServerData from "../../../provider/FetchServerData";
// import UiUtils from "../../../provider/UiUtils";
import Utils from "../../../provider/Utils";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import store from "../../../redux/store";
import { withRouter } from "../../../withRouter";
// import PtsButton from "../buttons/PtsButton";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import {
  DeleteMessage_Url,
  MessageList_Url,
} from "../../../provider/ServiceUrl";
import DeleteButton from "../buttons/DeleteButton";
import PtsAlert from "../ptsAlert/PtsAlert";
import CreateSimilerButton from "../buttons/CreateSimilerButton";
import QRCodeDialog from "./QRCodeDialog";
import { BUSINESS_DOMAIN, MESSAGE_TYPES } from "../../../provider/Enums";
import WidgetTemplate from "../widgetTemplate/WidgetTemplate";
import Thermometer from "../../../assets/img/Thermometer.png";
import "./Message.css";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import ImageIcon from "../../../assets/img/ImageIcon.png";
import VideoIcon from "../../../assets/img/VideoIcon.png";
import vCard from "../../../assets/img/vCard.png";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import PreviewDialog from "./PreviewDialog";
import MmsImage from "./MmsImage";
import _ from "lodash";
import VCardDialog from "./VCardDialog";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import Pagination from "../pagination/Pagination";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
class MessageList extends Component {
  header = store.getState().header.header;
  messageState = store.getState().applicationState.messageState;
  paginationState = store.getState().paginations.smsMessagesState;
  accountSettings = store.getState().accountSetting?.accountSetting;
  eventTypeList = store.getState().staticData.eventTypes;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  tollFreeNumberStatus =
    store.getState().appUserData.tollFreeNumberStatus;
  smsCategoryColorList = store.getState().staticData?.smsCategoryColorList;
  tollfreeNumber = store.getState().appUserData.tollfreeNumber;
  messageStateDetails = {};
  paginationStateDetails = {};
  breadCrumb = [{ pageid: "", uiname: "Messages" }];
  title = "Create, manage and send text messages";

  MMS_TYPES = ["video", "image"];
  MMS_TITLES = {
    video: "MMS Video",
    image: "MMS Image",
  };
  MMS_ICONS = {
    video: VideoIcon,
    image: ImageIcon,
  };
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.topRef = React.createRef();
    let eventId = "";
    if (this.messageState) {
      this.messageStateDetails = Object.getOwnPropertyNames(this.messageState);
    }
    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }

    if (props.state) {
      eventId = props.state.eventId;
    }

    if (this.messageStateDetails.length > 0) {
      this.state = {
        eventId: eventId,
        searchText: this.messageState.searchText,
        pageNo: this.messageState.pageNo,
        pageSize: this.messageState.pageSize,
        messageId: this.messageState.messageId,
        smsMessageList: [],
        smsVariableList: [],
        isPaging: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        isDownloadReport: false,
        isWidgetOpen: false,
        render: false,
        hoveredOptionId: null,
        sortColumn: this.messageState?.sortColumn,
        isAscSort: this.messageState?.isAscSort,
        sortDirection: "asc",
      };
    } else {
      this.state = {
        eventId: eventId,
        pageNo: 0,
        pageSize:
          this.paginationStateDetails?.length > 0
            ? this.paginationState?.pageSize
            : 100,
        searchText: "",
        messageId: "",
        smsMessageList: [],
        smsVariableList: [],
        isPaging: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        getReportPermission: false,
        isDownloadReport: false,
        isWidgetOpen: false,
        render: false,
        hoveredOptionId: null,
        sortColumn: this.paginationStateDetails?.length > 0
          ? this.paginationState?.sortColumn : null,
        isAscSort: this.paginationStateDetails?.length > 0
          ? this.paginationState?.isAscSort : false,
        sortDirection: "asc",
      };
    }
    this.getMessageList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
    this.debouncedSearch = _.debounce(this.getMessageList, 800);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }
  removeSearchChange() {
    let messageState = {
      messageId: this.state.messageId,
      searchText: "",
      pageNo: 0,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );
    this.setState({ searchText: "", pageNo: 0 }, () => {
      this.getMessageList(0, this.state.pageSize);
    });
  }

  getMessageList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(MessageList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsMessageList = output.data.smsMessageList;
          let smsVariableList = output.data.smsVariableList;
          let smsCredits = output.data.smsCredits;
          let accountSetting = output.data.accountSetting;
          let page = output.data.page;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getSubDomainPermission =
            output.data.subDomainObjectPrivileges?.MessageReport;
          let getCreatePermission = getPermission[1];
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let getReportPermission =
            getSubDomainPermission === null ? false : true;
          let isPaging = false;
          if (smsMessageList.length > this.state.pageSize) {
            isPaging = true;
          }

          if (smsCredits !== null) {
            const { showCardexpiryMessage, ...smsCreditsWithoutFlag } = smsCredits;

            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCreditsWithoutFlag)
              );
            } else {
              store.dispatch(
                AppUserDataAction.setUsage(smsCreditsWithoutFlag)
              );
            }
          }

          store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
          this.setState({
            render: true,
            isPaging: isPaging,
            smsMessageList: smsMessageList,
            smsVariableList: smsVariableList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            getCreatePermission: getCreatePermission,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
            getReportPermission: getReportPermission,
          });
        } else {
        }
      }
    );
  }

  addMessage() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessage", {
        state: {
          action: "create",
          eventId: this.state.eventId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessage", {
        state: {
          action: "create",
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else {
      this.props.navigate("/message", {
        state: {
          action: "create",
          eventId: this.state.eventId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    }
  }

  toMessageDetails(data) {
    let messageState = {
      messageId: data.id,
      searchText: this.state.searchText,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessage", {
        state: {
          action: "view",
          messageId: data.id,
          eventId: this.state.eventId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessage", {
        state: {
          action: "view",
          messageId: data.id,
          eventId: this.state.eventId,
        },
      });
    } else {
      this.props.navigate("/message", {
        state: {
          action: "view",
          messageId: data.id,
          eventId: this.state.eventId,
        },
      });
    }
  }

  showMessageDetails(rowData) {
    return (
      <>
        {this.state.getUpdatePermission ? (
          <span
            className="anchortag action-text"
            onClick={(e) => this.editMessageDetails(e, rowData)}
          >
            {rowData.messagename}{" "}
            {rowData.mmsType?.toLowerCase() === "video" ||
              rowData.mmsType?.toLowerCase() === "image"
              ? "(MMS)"
              : ""}
          </span>
        ) : (
          <span>
            {rowData.messagename}{" "}
            {rowData.mmsType?.toLowerCase() === "video" ||
              rowData.mmsType?.toLowerCase() === "image"
              ? "(MMS)"
              : ""}
          </span>
        )}
      </>
    );
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ pageNo: page, pageSize: pageSize });
  }

  handleScrollToTop = () => {
    if (this.topRef.current) {
      this.topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  createSimilarMessageDetails(data) {
    let messageState = {
      messageId: data.id,
      searchText: this.state.searchText,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventCreateSimilarMessage", {
        state: {
          action: "create",
          messageId: data.id,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextCreateSimilarMessage", {
        state: {
          action: "create",
          messageId: data.id,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else {
      this.props.navigate("/createSimilarMessage", {
        state: {
          action: "create",
          messageId: data.id,
          smsVariableList: this.state.smsVariableList,
        },
      });
    }
  }

  handleSearchChange(searchText) {
    const filteredData = this.state.smsMessageList.filter((row) =>
      row.messagename.toLowerCase().includes(searchText.toLowerCase())
    );

    let messageState = {
      messageId: this.state.messageId,
      searchText: searchText,
      pageNo: 0,
      pageSize: 100,
    };

    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );

    let isPaging = false;
    if (filteredData?.length > 100) {
      isPaging = true;
    }
    this.setState({
      searchText: searchText,
      isPaging: isPaging,
      pageNo: 0,
    });
  }
  editMessageDetails(e, data) {
    let messageState = {
      messageId: data.id,
      searchText: this.state.searchText,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessage", {
        state: {
          action: "edit",
          messageId: data.id,
          pageId: "MessageList",
          eventId: this.state.eventId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessage", {
        state: {
          action: "edit",
          messageId: data.id,
          pageId: "MessageList",
          eventId: this.state.eventId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else {
      this.props.navigate("/message", {
        state: {
          action: "edit",
          messageId: data.id,
          pageId: "MessageList",
          eventId: this.state.eventId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    }
  }

  deleteMessageToBackend(data) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: data.id,
      },
    };

    FetchServerData.callPostService(DeleteMessage_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          // this.getMessageList();
          const updatedList = this.state.smsMessageList.filter(
            (msg) => msg.id !== data.id
          );

          this.setState({
            smsMessageList: updatedList,
            render: true, // if needed
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  toPledgeDetails(data) {
    let messageState = {
      messageId: data.id,
      searchText: this.state.searchText,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventPledge", {
        state: {
          messageId: data.id,
          action: "view",
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextPledge", {
        state: {
          messageId: data.id,
          action: "view",
        },
      });
    } else {
      this.props.navigate("/pledge", {
        state: {
          messageId: data.id,
          action: "view",
        },
      });
    }
  }

  toMMSImageDropdownOpen = (e, rowData) => {
    let anchorEl = e.currentTarget;
    if (
      this.mmsImagePreviewDialogueRef &&
      this.mmsImagePreviewDialogueRef.current
    ) {
      this.mmsImagePreviewDialogueRef.current.showMmsImagePreview(
        anchorEl,
        rowData
      );
    }
  };

  onClickShowVCardFile = (e, rowData) => {
    if (this.vCardRef && this.vCardRef.current) {
      this.vCardRef.current.showVCardDetails(null, rowData.id);
    }
  };

  exportMessageData(data) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: data.id,
      },
    };

    FetchServerData.callPostService(
      "/csvImpExpms/exportMessageData",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let csvMessageData = output.data;
          const byteArray = new Buffer(
            csvMessageData.data.replace(/^.+base64,/, ""),
            "base64"
          );
          const outputFilename = csvMessageData.filename;
          const url = URL.createObjectURL(new Blob([byteArray]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", outputFilename);
          document.body.appendChild(link);
          link.click();
        } else {
        }
      })
      .catch((error) => { });
  }
  showActionButton(rowData) {
    const hideTypes = ["vCard", "CventConfirmationText"];
    return (
      <>
        <div className="row d-flex action-button" style={{ float: "left" }}>
          <div className="col-md-12 d-flex">
            {this.state.getCreatePermission && (
              !hideTypes.includes(rowData.messagetype) ?
                <span style={{ cursor: "pointer" }} ref={this.topRef}>
                  <CreateSimilerButton
                    onClick={(e) => this.createSimilarMessageDetails(rowData)}
                  />
                </span> : <span style={{ width: "33px" }} />
            )}
            <span style={{ cursor: "pointer" }}>
              {this.state.getReportPermission ? (
                <Tooltip
                  title="Download Report"
                  classes={{ popper: "custom-tooltip" }}
                  arrow
                >
                  <DownloadForOfflineIcon
                    style={{
                      borderRadius: "25%",
                      color: "#6A7B8E",
                      fontSize: "x-large",
                      width: "30px",
                      minHeight: "30px",
                      padding: "3px",
                    }}
                    onClick={(e) => this.exportMessageData(rowData)}
                  />
                </Tooltip>
              ) : (
                <Tooltip
                  title="Download Report"
                  classes={{ popper: "custom-tooltip" }}
                  arrow
                >
                  <DownloadForOfflineIcon
                    style={{
                      borderRadius: "25%",
                      color: "#6A7B8E",
                      fontSize: "x-large",
                      width: "30px",
                      minHeight: "30px",
                      padding: "3px",
                    }}
                    onClick={this.handleDownloadReportOpen.bind(this)}
                  />
                </Tooltip>
              )}
            </span>
            {rowData.messagetype !== "CventConfirmationText" &&
              <span style={{ cursor: "pointer" }}>
                {this.state.getDeletePermission && (
                  <DeleteButton
                    domainObject={rowData.messagename}
                    pageId="Message"
                    onClick={() => this.deleteMessageToBackend(rowData)}
                  />
                )}
              </span>
            }
          </div>
        </div>
      </>
    );
  }

  toQRCodeDetails(data) {
    if (this.QRCodeDialogueRef && this.QRCodeDialogueRef.current) {
      this.QRCodeDialogueRef.current.showQRCode(data);
    }
  }
  toPreviewDetails(data) {
    if (this.PreviewDialogueRef && this.PreviewDialogueRef.current) {
      this.PreviewDialogueRef.current.showQRCode(data);
    }
  }

  toWidgetDetails(data) {
    if (
      this.WidgetTemplateDialogueRef &&
      this.WidgetTemplateDialogueRef.current
    ) {
      this.WidgetTemplateDialogueRef.current.showWidgetDetails(data);
    }
  }

  // toWidgetDetails(data) {
  //   let messageState = {
  //     messageId: data.id,
  //     pageNo: this.state.pageNo,
  //     pageSize: this.state.pageSize,
  //   };
  //   store.dispatch(
  //     ApplicationStateAction.setApplicationState({ messageState })
  //   );
  //   if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
  //     this.props.navigate("/eventWidgetTemplate", {
  //       state: {
  //         action: "view",
  //         messageId: data.id,
  //       },
  //     });
  //   } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
  //     this.props.navigate("/dptextWidgetTemplate", {
  //       state: {
  //         action: "view",
  //         messageId: data.id,
  //       },
  //     });
  //   } else {
  //     this.props.navigate("/widgetTemplate", {
  //       state: {
  //         action: "view",
  //         messageId: data.id,
  //       },
  //     });
  //   }
  // }

  showWidgetButton(rowData) {
    return (
      <>
        <div className="row justify-content-around action-button">
          <div className="col-md-12 d-flex ps-1 pe-1">
            {(rowData.keyword !== "" && rowData.keyword !== null) ? (
              <div className="col-sm-6">
                {(this.tollfreeNumber !== null &&
                  this.tollfreeNumber !== undefined) && (
                    <Button
                      type="submit"
                      variant="contained"
                      id="ptsButton"
                      // endIcon={<QrCode2Icon />}
                      onClick={this.toQRCodeDetails.bind(this, rowData)}
                    >
                      QR Code
                    </Button>
                  )}
              </div>
            ) : (
              <div
                className="col-sm-6"
              ></div>
            )}
            {this.accountSettings?.enableWidget && (
              <>
                {!(
                  Utils.equalsIgnoreCase(
                    rowData.messagetype,
                    MESSAGE_TYPES.textToPledge
                  ) ||
                  Utils.equalsIgnoreCase(
                    rowData.messagetype,
                    MESSAGE_TYPES.accountvCard
                  )
                ) ? (
                  <div className="col-sm-6">
                    <Button
                      type="submit"
                      variant="contained"
                      id="ptsButton"
                      // endIcon={<ContactsIcon style={{ fontSize: "16px" }} />}
                      onClick={this.toWidgetDetails.bind(this, rowData)}
                    >
                      Widget
                    </Button>
                  </div>
                ) : (
                  <div
                    className="col-sm-6"
                  ></div>
                )}
              </>
            )}
          </div>
        </div >
      </>
    );
  }
  showPreviewAndSendButton(rowData) {
    // --- Normalize MMS data ---
    const type = (rowData?.mmsType || "").toLowerCase();
    const tooltip = this.MMS_TITLES?.[type] || "";
    const IconSrc = this.MMS_ICONS?.[type] || "";
    const isSupported = this.MMS_TYPES?.map((t) => t.toLowerCase()).includes(
      type
    );

    // --- Determine message type ---
    const isOptInOrTextToPledge =
      Utils.equalsIgnoreCase(rowData.messagetype, MESSAGE_TYPES.optIn) ||
      Utils.equalsIgnoreCase(rowData.messagetype, MESSAGE_TYPES.textToPledge);

    // --- Toll-free verification (optional) ---
    const isTollFreeVerified =
      this.tollFreeNumberStatus === "Verified" ||
      this.tollFreeNumberStatus === "Approved";

    return (
      <div className="row action-button">
        {/* LEFT SIDE: Preview Buttons */}
        <div
          className="col-md-8 align-items-start pe-0"
          style={{ textAlign: "left" }}
        >
          {!isOptInOrTextToPledge ? (
            isTollFreeVerified ?
              <Button
                id="ptsSolidButton"
                variant="contained"
                onClick={() => this.toPriviewAndSendDetails(rowData)}
              >
                Preview & Send
              </Button>
              :
              <Tooltip
                title="Messages cannot be sent or scheduled until the phone number is verified."
                classes={{ popper: "custom-tooltip" }}
                arrow
              >
                <span>
                  <Button
                    id="ptsSolidButton"
                    variant="contained"
                    disabled
                    onClick={() => this.toPriviewAndSendDetails(rowData)}
                  >
                    Preview & Send
                  </Button>
                </span>
              </Tooltip>

          ) : (
            isTollFreeVerified ?
              <Button
                id="ptsSolidButton"
                variant="contained"
                style={{ width: "122.98px" }}
                onClick={() => this.toPreviewDetails(rowData)}
              >
                Preview
              </Button>

              :
              <Tooltip
                title="Messages cannot be sent or scheduled until the phone number is verified."
                classes={{ popper: "custom-tooltip" }}
                arrow
              >
                <span>
                  <Button
                    id="ptsSolidButton"
                    variant="contained"
                    style={{ width: "122.98px" }}
                    disabled
                    onClick={() => this.toPreviewDetails(rowData)}
                  >
                    Preview
                  </Button>
                </span>
              </Tooltip>
          )
          }
        </div>

        {/* RIGHT SIDE: MMS Icon + Fundraising */}
        <div className="col-md-4 text-center p-0">
          {/* Fundraising Meter */}
          {rowData.isPledge ? (
            <span style={{ cursor: "pointer", paddingRight: "14px" }}>
              <Tooltip
                title="Fundraising Meter"
                classes={{ popper: "custom-tooltip" }}
                arrow
              >
                <img
                  src={Thermometer}
                  style={{ width: "22.5px", height: "22.5px" }}
                  alt="Fundraising Meter"
                  onClick={() => this.toPledgeDetails(rowData)}
                />
              </Tooltip>
            </span>
          ) : (
            <span
              style={{ paddingRight: "36px" }}
            />
          )}

          {/* MMS Icon (only if supported) */}
          {isSupported ? (
            <span style={{ cursor: "pointer" }}>
              <Tooltip title={tooltip} classes={{ popper: "custom-tooltip" }} arrow>
                {/* <a
                href="#" 
                  onClick={(e) =>
                    type === "vcard"
                      ? this.onClickShowVCardFile(e, rowData)
                      : this.toMMSImageDropdownOpen(e, rowData)
                  }
                  rel="noreferrer"
                  role="button"
                  tabIndex="0"
                  style={{ color: "#fff" }}
                >
                  <img
                    src={IconSrc}
                    style={{
                      width: "22.5px",
                      height: "22.5px",
                      borderRadius: type === "vcard" ? "5px" : "0px",
                    }}
                    alt={`${type} icon`}
                  />
                </a> */}
                <button
                  type="button"
                  onClick={(e) =>
                    type === "vcard"
                      ? this.onClickShowVCardFile(e, rowData)
                      : this.toMMSImageDropdownOpen(e, rowData)
                  }
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  <img
                    src={IconSrc}
                    style={{
                      width: "22.5px",
                      height: "22.5px",
                      borderRadius: type === "vcard" ? "5px" : "0px",
                    }}
                    alt={`${type} icon`}
                  />
                </button>
              </Tooltip>
            </span>
          ) : rowData.messagetype?.toLowerCase() === "vcard" && rowData?.isVcard ? (
            <span style={{ cursor: "pointer" }}>
              <Tooltip title="vCard" classes={{ popper: "custom-tooltip" }} arrow>
                <a
                  onClick={(e) => this.onClickShowVCardFile(e, rowData)}
                  rel="noreferrer"
                  style={{ color: "#fff" }}
                >
                  <img
                    src={vCard}
                    style={{
                      width: "22.5px",
                      height: "22.5px",
                      borderRadius: "5px",
                    }}
                    alt={`vCard icon`}
                  />
                </a>
              </Tooltip>
            </span>
          ) : (
            // If not supported, show placeholder space
            <span
              style={{ paddingLeft: "25px" }}
            />
          )}
        </div>
      </div >
    );
  }

  toPriviewAndSendDetails(data) {
    let messageState = {
      messageId: data.id,
      searchText: this.state.searchText,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventPreviewAndSend", {
        state: {
          action: "view",
          messageId: data.id,
          messagename: data.messagename,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextPreviewAndSend", {
        state: {
          action: "view",
          messageId: data.id,
          messagename: data.messagename,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else {
      this.props.navigate("/previewAndSend", {
        state: {
          action: "view",
          messageId: data.id,
          messagename: data.messagename,
          smsVariableList: this.state.smsVariableList,
        },
      });
    }
  }

  toQwiktextDetails() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventQwiktext", {
        state: {
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextQwiktext", {
        state: {
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else {
      this.props.navigate("/qwiktext", {
        state: {
          smsVariableList: this.state.smsVariableList,
        },
      });
    }
  }
  toShortLinkDetails() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventShortLinkList");
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextShortLinkList");
    } else {
      this.props.navigate("/shortLinkList");
    }
  }
  handleDownloadReportClose() {
    this.setState({
      isDownloadReport: false,
    });
  }
  handleDownloadReportOpen() {
    this.setState({
      isDownloadReport: true,
    });
  }
  showAddButton() {
    return (
      <>
        {this.state.getCreatePermission && (
          <span>
            {/* <PtsButton btnName="Add New Message" type="submit" /> */}
            <Button
              id="ptsGreenSolidButton"
              variant="contained"
              type="submit"
              startIcon={
                <SmsIcon style={{ fontWeight: "600", fontSize: "16px" }} />
              }
              onClick={(event) => this.addMessage(event)}
            >
              Add New Message
            </Button>
          </span>
        )}
        <span className="ms-3">
          <Button
            id="sendQuicktextButton"
            variant="contained"
            style={{ textTransform: "initial" }}
            type="submit"
            startIcon={
              <FeedbackIcon style={{ fontWeight: "600", fontSize: "16px" }} />
            }
            onClick={(event) => this.toQwiktextDetails(event)}
          >
            Send a Quick Text
          </Button>
        </span>
      </>
    );
  }

  handleColorCodeChange = (event, rowData) => {
    this.updateColorToBacked(rowData);
    const updatedList = this.state.smsMessageList.map((item) => {
      if (item.id === rowData.id) {
        return { ...item, hashColor: event.target.value };
      }
      return item;
    });
    this.setState({ smsMessageList: updatedList });
  };

  handleUpdateColorToBacked(event, rowData) {
    const selectedHashColor = event.target.value;

    // Find color option by hashColor
    const selectedColor = this.smsCategoryColorList?.find(
      (opt) => opt.hashColor === selectedHashColor
    );
    const postObject = {
      header: this.header,
      smsMessage: {
        id: rowData.id,
        categoryColor: {
          id: selectedColor.id,
        },
        event: {
          id: this.businessDomainId,
        },
      },
    };

    FetchServerData.callPostService(
      "/smsmessagems/updateColor",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        this.getMessageList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
      } else {
      }
    });
  }

  handleWidgetTemplateOpen() {
    this.setState({
      isWidgetOpen: true,
    });
  }
  handleWidgetTemplateClose() {
    this.setState({
      isWidgetOpen: false,
    });
  }
  onMouseEnter = (optionId) => {
    this.setState({ hoveredOptionId: optionId });
  };
  onMouseLeave = () => {
    this.setState({ hoveredOptionId: null });
  };

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const smsMessagesState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setSmsMessagesPaginationState({ smsMessagesState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getMessageList(pageNo, pageSize, column, isAscSort);
      }
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const smsMessagesState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setSmsMessagesPaginationState({ smsMessagesState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getMessageList(currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  render() {
    let smsCategoryColorList =
      store.getState().staticData?.smsCategoryColorList;
    this.WidgetTemplateDialogueRef = React.createRef();
    this.QRCodeDialogueRef = React.createRef();
    this.PreviewDialogueRef = React.createRef();
    this.mmsImagePreviewDialogueRef = React.createRef();
    this.vCardRef = React.createRef();

    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
          isSearchText={this.state.searchText !== ""}
        />
        <WidgetTemplate
          ref={this.WidgetTemplateDialogueRef}
          style={{ float: "right" }}
        />
        <QRCodeDialog ref={this.QRCodeDialogueRef} style={{ float: "right" }} />
        <PreviewDialog
          ref={this.PreviewDialogueRef}
          style={{ float: "right" }}
        />
        <MmsImage
          ref={this.mmsImagePreviewDialogueRef}
          style={{ float: "right" }}
        />
        <VCardDialog ref={this.vCardRef} style={{ float: "right" }} />
        <div className="row">
          <div className="col">
            <div className="col md-12">
              <div className="card rounded-0">
                <div
                  className="row justify-content-between"
                  style={{ padding: "0.6em 1.2rem" }}
                >
                  <div className="d-flex col-12 col-lg-5 col-xl-5 ps-2">
                    <div className="col-12 text-start totalResults align-self-center d-flex">
                      {this.showAddButton()}
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                    <span className="me-2">
                      <Button
                        id="ptsHollowButton"
                        variant="contained"
                        style={{ textTransform: "initial" }}
                        type="button"
                        onClick={() => this.toShortLinkDetails()}
                        startIcon={
                          <AddLinkIcon
                            style={{ fontWeight: "600", fontSize: "16px" }}
                          />
                        }
                      >
                        Short Links
                      </Button>
                    </span>
                    <TextField
                      id="standard-search"
                      placeholder="Search"
                      className="message-search-field"
                      type="text"
                      variant="standard"
                      value={this.state.searchText}
                      onChange={this.onSearchChange.bind(this)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              onClick={this.getMessageList.bind(
                                this,
                                0,
                                this.state.pageSize
                              )}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.removeSearchChange.bind(this)}
                              disabled={!this.state.searchText}
                            >
                              <ClearIcon
                                style={{
                                  opacity: this.state.searchText ? 1 : 0.4,
                                  fontSize: "1.25rem",
                                  color: "353538",
                                }}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="table-responsive paginationTable">
                  <table className="table text-start table-hover">
                    <thead className="paginationTableThead">
                      <tr>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("hashColor")}>
                          {this.state.sortColumn === "hashColor" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("messagename")}
                        >
                          Message Title
                          {this.state.sortColumn === "messagename" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("keyword")}>Keyword
                          {this.state.sortColumn === "keyword" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="col fw-bold"></th>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("messagetype")}>Msg Type
                          {this.state.sortColumn === "messagetype" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>

                        <th className="col fw-bold">Opt-in Tool</th>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("createdby")}>Creator
                          {this.state.sortColumn === "createdby" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("lastActivity")} >
                          <Tooltip
                            title="Date created/edited/sent/replied to"
                            classes={{ popper: "custom-tooltip" }}
                            arrow
                          >
                            <span>
                              Last Used
                            </span>
                          </Tooltip>
                          {this.state.sortColumn === "lastActivity" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="col fw-bold">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.smsMessageList?.map((rowData, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor:
                              rowData.id === this.state.messageId
                                ? "#e6effc"
                                : "",
                          }}
                        >
                          <td
                            style={{ width: "40px" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <span
                              className="action-button messageListColorCode"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Select
                                value={
                                  smsCategoryColorList?.some(
                                    (opt) => opt.hashColor === rowData.hashColor
                                  )
                                    ? rowData.hashColor
                                    : ""
                                }
                                onChange={(e) => {
                                  e.stopPropagation();
                                  this.handleUpdateColorToBacked(e, rowData);
                                }}
                                className="selectColorCode action-button"
                                style={{ backgroundColor: rowData.hashColor }}
                                renderValue={() => null}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 250,
                                      overflowY: "auto",
                                    },
                                  },
                                  MenuListProps: {
                                    className: "colorMenuListWrap",
                                  },
                                  anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                }}
                              >
                                {smsCategoryColorList?.map((option) => (
                                  <MenuItem
                                    key={option.id}
                                    value={option.hashColor}
                                    className="colorCodeMenuItem"
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                      padding: "8px",
                                      "&:hover": {
                                        backgroundColor: "#e6effc",
                                        "& div": {
                                          transform: "scale(1.1)",
                                          boxShadow: "0 0 4px #e6effc",
                                          borderRadius: "3px",
                                        },
                                      },
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: option.hashColor,
                                        width: 18,
                                        height: 18,
                                        borderRadius: 3,
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                  </MenuItem>
                                ))}
                              </Select>
                            </span>
                          </td>
                          <td style={{ width: "250px" }}>
                            {rowData.messagetype === "CventConfirmationText" ?
                              <span className="anchortag action-text">
                                {rowData.messagename}
                              </span>
                              :
                              <span className="anchortag action-text">
                                {this.showMessageDetails(rowData)}
                              </span>
                            }
                          </td>
                          <td
                            style={{ width: "145px" }}
                          >
                            {rowData.keyword !== "" && rowData.keyword !== null
                              ? `"${rowData.keyword}"`
                              : ""}
                          </td>
                          <td style={{ width: "250px" }}>
                            {rowData.messagetype === "CventConfirmationText" ?
                              <Button
                                id="ptsSolidButton"
                                variant="contained"
                                style={{ width: "122.98px" }}
                                onClick={() => this.toPriviewAndSendDetails(rowData)}
                              >
                                Preview
                              </Button>
                              : this.showPreviewAndSendButton(rowData)}
                          </td>
                          <td
                            style={{ width: "120px" }}
                          >
                            {rowData.messageTypeDetail}
                          </td>

                          <td style={{ width: "225px" }}>
                            {rowData.messagetype === "CventConfirmationText" ? "" : this.showWidgetButton(rowData)}
                          </td>
                          <td
                            style={{ width: "100px" }}
                          >
                            <Tooltip
                              title={rowData.createdbyName}
                              classes={{ popper: "custom-tooltip" }}
                              arrow
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  cursor: "pointer",
                                }}
                              >
                                {rowData.createdby}
                              </span>
                            </Tooltip>
                          </td>
                          <td
                            style={{ width: "120px" }}
                          >
                            {rowData.lastActivity !== null
                              ? rowData.lastActivity
                              : ""}
                          </td>
                          <td key={rowData.id} style={{ width: "120px" }}>
                            {this.showActionButton(rowData)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No messages found.</h5>
                  </div>
                )}
                {this.state.totalRecords > 10 && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        Page {this.state.pageNo + 1} of {this.state.totalPages}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          pageNo={this.state.pageNo}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <Dialog
          open={this.state.isDownloadReport}
          onClose={this.handleDownloadReportClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <span style={{ textAlign: "center" }}>
              <p className="mb-2" style={{ fontSize: "16px" }}>
                This feature is not enabled for your user type. Please contact
                admin.
              </p>
            </span>
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.isWidgetOpen}
          onClose={this.handleWidgetTemplateClose}
          maxWidth="xl"
          className="importContactDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Import Contacts</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleWidgetTemplateClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div className="row p-2">
              <div className="col-sm-12">
                <div className="row">
                  <span style={{ textAlign: "center" }}>
                    <p className="m-0" style={{ fontSize: "16px" }}>
                      Please contact customer support to activate this feature.
                    </p>
                  </span>
                </div>
                <div className="row mt-3 align-items-center">
                  <div class="col-md-12 text-center">
                    <Button
                      id="ptsButton"
                      type="button"
                      style={{
                        background: "#b6bec8",
                      }}
                    >
                      Contact Customer support
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

export default withRouter(MessageList);
